const UAR_CONSTANTS = {
	PAGE_DASHBOARD: 'PAGE_DASHBOARD',
	PAGE_ACCOUNT_DETAILS: 'PAGE_ACCOUNT_DETAILS',
	PAGE_DELEGATE: 'PAGE_DELEGATE',
	PAGE_ORG_CHART: 'PAGE_ORG_CHART',
	PAGE_REASSIGN: 'PAGE_REASSIGN',
	PAGE_RENEW: 'PAGE_RENEW',
	PAGE_TERMINATE: 'PAGE_TERMINATE',
	PAGE_UPDATE_PROFILE: 'PAGE_UPDATE_PROFILE',
	PAGE_REVIEW_EMPLOYEE_ACCESS: 'PAGE_REVIEW_EMPLOYEE_ACCESS',
	PAGE_VALIDATE: 'PAGE_VALIDATE',
	PAGE_DASHBOARD_ACTION: 'View Dashboard',
	PAGE_ACCOUNT_DETAILS_ACTION: 'View Account Details',
	PAGE_DELEGATE_ACTION: 'Delegate Account(s)',
	PAGE_ORG_CHART_ACTION: 'View Org Chart',
	PAGE_REASSIGN_ACTION: 'Reassign Account(s)',
	PAGE_TERMINATE_ACTION: 'Terminate Account(s)',
	PAGE_UPDATE_PROFILE_ACTION: 'Update Account Details',
	PAGE_VALIDATE_ACTION: 'Validate Account(s)',
	NON_EMPLOYEE: 'Non-Employee',
	NON_EMPLOYEE_KEY: 'nonEmployee',
	EMPLOYEE: 'Employee',
	EMPLOYEE_KEY: 'employee',
	CONTINGENT_WORKER: 'Contingent Worker',
	CONTINGENT_WORKER_KEY: 'contingentWorker',
	SERVICE_ACCOUNT: 'Service Account',
	SERVICE_ACCOUNT_KEY: 'serviceAccount',
	APPLICATION_MODIFY: 'MODIFY',
	APPLICATION_REVOKE: 'REVOKE',
};

export { UAR_CONSTANTS };

export const SUBMISSION_LOADING_TITLE = 'Please wait while your form submits.';
export const SUBMISSION_LOADING_BULK_MESSAGE =
	'Submitting for more than one account may take more time to process.';
